const riot = require('riot');

riot.tag2('atom-editor', '<div class="relative s-full" onmousedown="{onMousedown}" onmouseenter="{onEditorMouseEnter}" onmouseleave="{onEditorMouseLeave}"> <textarea ref="editor" placeholder="{opts.placeholder}"></textarea> <div class="absolute t10 r16 f fh w32 h28 rounded-6 bg-label_white_primary border border-separator_opacity cursor-pointer z5 transition {(isHoveringEditor &amp;&amp; !editor.hasFocus()) || this.popupToc ? \'\' : \'opacity-0\'}" if="{opts.shouldShowToc &amp;&amp; !editor.hasFocus()}" ref="tocButton" onclick="{openPopupToc}"><i class="text-label_dark fs16 {popupToc ? &quot;icon-close&quot; : &quot;icon-list&quot;}"></i></div> </div>', 'atom-editor,[data-is="atom-editor"]{display:block} atom-editor .CodeMirror textarea,[data-is="atom-editor"] .CodeMirror textarea{font-size:34px} atom-editor .cm-url,[data-is="atom-editor"] .cm-url{cursor:pointer} atom-editor .cm-url:hover,[data-is="atom-editor"] .cm-url:hover{text-decoration:underline currentColor} atom-editor .editor-message-codeblock,[data-is="atom-editor"] .editor-message-codeblock{background:transparent !important;border:none !important} atom-editor .editor-message-hidden,[data-is="atom-editor"] .editor-message-hidden{display:none !important} atom-editor .HyperMD-header.HyperMD-header-1,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-1{padding-left:0 !important;padding-bottom:4px} atom-editor .HyperMD-header.HyperMD-header-2,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-2{padding-top:calc(6px + var(--margin-y));padding-bottom:calc(8px + var(--margin-y));padding-left:16px !important;--margin-y:4px;mix-blend-mode:multiply} atom-editor .HyperMD-header.HyperMD-header-2:before,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-2:before{position:absolute;left:0;top:var(--margin-y);z-index:-1;display:block;content:\'\';height:calc(100% - var(--margin-y) * 2);width:100%;background-color:#F5F7FC;border-left:6px solid var(--project-color, #4466ea)} atom-editor .HyperMD-header.HyperMD-header-2:after,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-2:after{display:none !important} atom-editor .HyperMD-header.HyperMD-header-3,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-3{padding-top:calc(4px + var(--margin-y));padding-bottom:calc(6px + var(--margin-y));padding-left:12px !important;--margin-y:4px} atom-editor .HyperMD-header.HyperMD-header-3:before,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-3:before{position:absolute;top:var(--margin-y);left:0;z-index:-1;display:block;content:\'\';height:calc(100% - var(--margin-y) * 2);width:100%;border-left:4px solid var(--project-color, #4466ea);opacity:.7} atom-editor .HyperMD-header.HyperMD-header-3:after,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-3:after{position:absolute;left:4px;bottom:4px;display:block;content:\'\';height:1px;width:100%;background-color:#d8e0eb !important} atom-editor .HyperMD-header.HyperMD-header-4,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-4{padding-bottom:8px;padding-left:0 !important} atom-editor .HyperMD-header.HyperMD-header-4:before,[data-is="atom-editor"] .HyperMD-header.HyperMD-header-4:before{position:absolute;left:0;bottom:6px;display:block;content:\'\';height:1px;width:100%;background-color:#d8e0eb} atom-editor .cm-hashtag,[data-is="atom-editor"] .cm-hashtag{cursor:pointer} atom-editor .hmd-link-icon,[data-is="atom-editor"] .hmd-link-icon{cursor:pointer} atom-editor .CodeMirror-gutters,[data-is="atom-editor"] .CodeMirror-gutters{background-color:transparent;border-color:transparent} atom-editor .CodeMirror-placeholder,[data-is="atom-editor"] .CodeMirror-placeholder{color:rgba(29,40,76,0.46) !important} atom-editor .CodeMirror.composing-placeholder .CodeMirror-placeholder,[data-is="atom-editor"] .CodeMirror.composing-placeholder .CodeMirror-placeholder{display:none} atom-editor .cm-s-hypermd-light,[data-is="atom-editor"] .cm-s-hypermd-light{font-family:"Noto Sans JP","Hiragino Kaku Gothic ProN",Meiryo,sans-serif;font-size:inherit;background-color:inherit;color:#1C2236} atom-editor .cm-s-hypermd-light img.hmd-image,[data-is="atom-editor"] .cm-s-hypermd-light img.hmd-image{border:1px solid #ccc;max-width:50%} atom-editor .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-1,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-1{font-size:24px} atom-editor .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-1:after,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-1:after{display:none !important} atom-editor .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-2,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-2{font-size:18px} atom-editor .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-3,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-header.HyperMD-header-3{font-size:14px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-1,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-1{padding-left:32px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-2,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-2{padding-left:48px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-3,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-3{padding-left:64px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-4,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-4{padding-left:80px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-5,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-5{padding-left:96px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-6,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-6{padding-left:112px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-7,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-7{padding-left:128px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-8,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-8{padding-left:144px} atom-editor .cm-s-hypermd-light pre.HyperMD-list-line-9,[data-is="atom-editor"] .cm-s-hypermd-light pre.HyperMD-list-line-9{padding-left:160px} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-1,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-1{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-1:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-1:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-3,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-3{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-3:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-3:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-5,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-5{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-5:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-5:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-7,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-7{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-7:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-7:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-9,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-9{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-9:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-9:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10{color:transparent;position:relative;text-shadow:none} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10:before{content:\'\';display:block;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;transform:translateX(100%);background-color:black;width:4px;height:4px;border-radius:50%} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-2:before{background-color:white;border:1px solid black} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-4:before{background-color:white;border:1px solid black} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-6:before{background-color:white;border:1px solid black} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-8:before{background-color:white;border:1px solid black} atom-editor .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10:before,[data-is="atom-editor"] .cm-s-hypermd-light span.cm-formatting-list.cm-formatting-list-ul.cm-list-10:before{background-color:white;border:1px solid black} atom-editor .CodeMirror .HyperMD-table-row,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row{max-width:100%;overflow-x:auto;scrollbar-width:none} atom-editor .CodeMirror .HyperMD-table-row::-webkit-scrollbar,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row::-webkit-scrollbar{display:none} atom-editor .CodeMirror .HyperMD-table-row .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row .hmd-table-column{font-family:Arial,Helvetica,sans-serif;padding:4px;text-align:left;background-color:#fff;margin:0 !important;border-collapse:collapse;pointer-events:auto} atom-editor .CodeMirror .HyperMD-table-row .hmd-table-column:hover,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row .hmd-table-column:hover{opacity:.7} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-32 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-32 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-30 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-30 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-28 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-28 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-26 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-26 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-24 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-24 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-22 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-22 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-20 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-20 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-18 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-18 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-16 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-16 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-14 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-14 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-12 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-12 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-10 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-10 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-8 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-8 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-6 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-6 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-4 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-4 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-2 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-2 .hmd-table-column{background-color:#f2f2f2} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-0 .hmd-table-column,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-0 .hmd-table-column{padding-top:6px;padding-bottom:6px;text-shadow:0 0 1.5px black;opacity:.6;background-color:var(--project-color, #4466ea);color:white;font-weight:bold} atom-editor .CodeMirror .HyperMD-table-row.HyperMD-table-row-1,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row.HyperMD-table-row-1{visibility:hidden !important;height:0 !important;padding:0 !important;margin:0 !important;border:none !important;font-size:0 !important} atom-editor .CodeMirror .HyperMD-table-row .hmd-table-column-dummy,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row .hmd-table-column-dummy,atom-editor .CodeMirror .HyperMD-table-row .cm-hmd-table-sep-dummy,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row .cm-hmd-table-sep-dummy{display:none !important} atom-editor .CodeMirror .HyperMD-table-row .cm-hmd-table-sep,[data-is="atom-editor"] .CodeMirror .HyperMD-table-row .cm-hmd-table-sep{width:0 !important} atom-editor .cm-em,[data-is="atom-editor"] .cm-em{font-style:normal;padding:0 .12em;color:black;background-image:linear-gradient(to bottom, transparent 65%, #4466ea61 35%);background-size:100% 50%;background-position:0 75%}', '', function(opts) {
    const ONE_FRAME_MS = 16;

    this.isUploading = false;

    this.isHoveringEditor = false;

    this.messageMarks = [];

    this.messageLineHandles = [];

    this.messageWidgetTags = [];

    this.messageRanges = [];

    this.frontmatterMark = null;

    this.frontmatterLineHandles = [];

    this.frontmatterWidgetTag = null;

    this.frontmatterRange = null;

    this.isFrontmatterUpdating = false;

    this._frontmatterParseCache = null;

    this._widgetUpdateRaf = null;

    this._onFrontmatterWidgetMousedown = null;
    this._frontmatterWidgetEl = null;

    this.insertUrlSelectedRange = async (e) => {

      let clipboard_text = e.clipboardData.getData('text');

      if (!app.utils.isURL(clipboard_text)) return ;

      const editor = this.editor;

      let selected_string = editor.getSelection();

      if (!selected_string || app.utils.isURL(selected_string.trim())) return ;

      e.preventDefault();

      editor.replaceSelection(clipboard_text);

      this.util.setSelectionByString(clipboard_text);

      const formatted_text = `[${selected_string}](${clipboard_text})`;

      editor.replaceSelection(formatted_text);

      spat.toast.message('クリップボードからリンクを挿入しました。', { icon:"copy", timeout: 1024})
    };

    this.showPopupMenu = _.debounce(async (selected_text) => {

      if (this.overlay) return ;

      let items = [
        { icon: 'bold', tooltip: `ボールド  ${app.shortcut.getCtrlKeyLabel()} + B`, symbol: '**', type: 'enclosing' },
        { icon: 'minus', tooltip: `マーカーを引く  ${app.shortcut.getCtrlKeyLabel()} + I`, symbol: '*', type: 'enclosing', isHide: app.useragent?.isMobile },
        { icon: 'strikethrough', tooltip: `取り消し線  ${app.shortcut.getCtrlKeyLabel()} + D`, symbol: '~~', type: 'enclosing' },
        { icon: 'block', tooltip: 'コードブロック  `', symbol: '`', type: 'block' },
        { icon: 'list', tooltip: 'リスト', symbol: '-', type: 'list' },
        { icon: 'checkbox', tooltip: 'チェックボックス', symbol: '- [ ]', type: 'list' },
        { icon: 'clip', tooltip: 'リンク挿入', symbol: '[](https://~)', type: 'link' },
      ].filter(item => !item.isHide);

      const $cursor = this.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      this.overlay = spat.popup.open('popup-tool-list', {
        offsetTop: cursorPosition.top - 36,
        offsetLeft: cursorPosition.left,
        opts: {
          items,
        },
      });

      this.overlay.on('selected', async ({ symbol, type }) => {

        if (type === 'enclosing'){
          this.util.replaceEnclosing(symbol);
        }

        else if (type === 'list') {
          this.util.replaceLineHead(symbol);
        }

        else if (type === 'block') {
          this.util.replaceCodeBlock();
        }

        else {
          this.util.replaceMarkdownLink(symbol);
        }
      });

      await this.overlay.waitClose();
      this.overlay = null;

    }, 512);

    this.widgetFactories = {

      message: (content, start_line) => this.createMessageWidget(content, start_line),
    };

    this.clearMessageWidgets = () => {

      this.messageWidgetTags.forEach(tag => tag.unmount());
      this.messageWidgetTags = [];

      this.messageMarks.forEach(mark => mark.clear());
      this.messageMarks = [];

      this.messageLineHandles.forEach(handle => {
        this.editor.removeLineClass(handle, 'background', 'editor-message-codeblock');
        this.editor.removeLineClass(handle, 'wrap', 'editor-message-hidden');
      });
      this.messageLineHandles = [];
      this.messageRanges = [];
    };

    this.createMessageWidget = (text, start_line) => {

      const mount_target = document.createElement('div');
      const widget_tag = riot.mount(mount_target, 'atom-message-block', { text, isEditor: true })[0];
      this.messageWidgetTags.push(widget_tag);

      mount_target.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const target_line = Math.min(start_line + 1, this.editor.lastLine());
        this.editor.focus();

        this.editor.setCursor({ line: target_line, ch: 0 });

        this.updateMessageWidgets(target_line);
      });

      return mount_target;
    };

    this.createFrontmatterWidget = (data) => {
      const mount_target = document.createElement('div');

      this._onFrontmatterWidgetMousedown = (e) => {
        if (e.target.closest('input, button')) return;
        e.preventDefault();
        e.stopPropagation();
        if (!this.frontmatterRange) return;
        const target_line = Math.min(this.frontmatterRange.start + 1, this.editor.lastLine());
        this.editor.focus();
        this.editor.setCursor({ line: target_line, ch: 0 });
      };
      mount_target.addEventListener('mousedown', this._onFrontmatterWidgetMousedown);
      this._frontmatterWidgetEl = mount_target;

      const widget_tag = riot.mount(mount_target, 'atom-frontmatter-table', {
        data,
        onChange: (new_data) => this.applyFrontmatterChange(new_data),
      })[0];
      this.frontmatterWidgetTag = widget_tag;
      return mount_target;
    };

    this.clearFrontmatterWidget = () => {
      if (this._frontmatterWidgetEl && this._onFrontmatterWidgetMousedown) {
        this._frontmatterWidgetEl.removeEventListener('mousedown', this._onFrontmatterWidgetMousedown);
        this._frontmatterWidgetEl = null;
        this._onFrontmatterWidgetMousedown = null;
      }
      if (this.frontmatterWidgetTag) {
        this.frontmatterWidgetTag.unmount();
        this.frontmatterWidgetTag = null;
      }
      if (this.frontmatterMark) {
        this.frontmatterMark.clear();
        this.frontmatterMark = null;
      }
      this.frontmatterLineHandles.forEach(handle => {
        this.editor.removeLineClass(handle, 'background', 'editor-message-codeblock');
        this.editor.removeLineClass(handle, 'wrap', 'editor-message-hidden');
      });
      this.frontmatterLineHandles = [];
      this.frontmatterRange = null;
    };

    this.detectFrontmatterRange = () => {
      const first_line = this.editor.firstLine();
      const first = this.editor.getLine(first_line);
      if (!first || first.trim() !== '---') return null;

      const last_line = this.editor.lastLine();
      for (let line = first_line + 1; line <= last_line; line++) {
        const text = this.editor.getLine(line);
        if (text && (text.trim() === '---' || text.trim() === '...')) {
          return { start: first_line, end: line };
        }
      }
      return null;
    };

    this.parseFrontmatterCached = (range) => {
      const end_ch = this.editor.getLine(range.end).length;
      const raw = this.editor.getRange({ line: range.start, ch: 0 }, { line: range.end, ch: end_ch });
      if (this._frontmatterParseCache && this._frontmatterParseCache.raw === raw) {
        return this._frontmatterParseCache.data;
      }
      const { data } = app.utils.parseFrontmatter(raw);
      this._frontmatterParseCache = { raw, data };
      return data;
    };

    this.updateFrontmatterWidget = (active_line = null) => {
      if (!this.editor) return;

      if (this.isFrontmatterUpdating) return;

      const range = this.detectFrontmatterRange();

      const has_focus = this.editor.hasFocus();
      const is_active = range !== null && has_focus && active_line !== null && active_line >= range.start && active_line <= range.end;
      if (!range || is_active) {
        this.clearFrontmatterWidget();
        return;
      }

      if (this.frontmatterRange && this.frontmatterRange.start === range.start && this.frontmatterRange.end === range.end) {
        const data = this.parseFrontmatterCached(range);
        if (!data) {
          this.clearFrontmatterWidget();
          return;
        }
        if (this.frontmatterWidgetTag) {
          this.frontmatterWidgetTag.update({ data });
        }
        return;
      }

      this.clearFrontmatterWidget();

      const data = this.parseFrontmatterCached(range);
      if (!data) return;

      const widget = this.createFrontmatterWidget(data);
      const end_ch = this.editor.getLine(range.end).length;

      this.frontmatterMark = this.editor.markText(
        { line: range.start, ch: 0 },
        { line: range.end, ch: end_ch },
        {
          replacedWith: widget,
          collapsed: true,
          inclusiveLeft: false,
          inclusiveRight: false,
          handleMouseEvents: true,
          clearOnEnter: false,
        }
      );

      for (let i = range.start; i <= range.end; i++) {
        const handle = this.editor.getLineHandle(i);
        this.frontmatterLineHandles.push(handle);
        this.editor.addLineClass(handle, 'background', 'editor-message-codeblock');

        if (i > range.start) {
          this.editor.addLineClass(handle, 'wrap', 'editor-message-hidden');
        }
      }

      this.frontmatterRange = range;
    };

    this.applyFrontmatterChange = (new_data) => {
      if (!this.frontmatterRange) return;

      const range = this.frontmatterRange;
      const end_ch = this.editor.getLine(range.end).length;

      this.isFrontmatterUpdating = true;

      if (!new_data || Object.keys(new_data).length === 0) {

        const last_line = this.editor.lastLine();
        const next_line = range.end + 1;
        if (next_line <= last_line) {
          this.editor.replaceRange('', { line: range.start, ch: 0 }, { line: next_line, ch: 0 });
        }
        else {
          this.editor.replaceRange('', { line: range.start, ch: 0 }, { line: range.end, ch: end_ch });
        }
      }
      else {

        const replacement = app.utils.stringifyFrontmatter(new_data, '').replace(/\n+$/, '');
        this.editor.replaceRange(
          replacement,
          { line: range.start, ch: 0 },
          { line: range.end, ch: end_ch }
        );
      }

      this.isFrontmatterUpdating = false;

      this.clearFrontmatterWidget();
      this.updateFrontmatterWidget(this.editor.getCursor().line);
    };

    this.setupTableScrollSync = () => {
      const cm_code = this.root.querySelector('.CodeMirror-code');
      if (!cm_code) return;
      this.tableScrollTarget = cm_code;
      this.handleTableScroll = (e) => {
        const row = e.target;

        if (!row.classList?.contains('HyperMD-table-row')) return;
        const cls = [...row.classList].find((c) => c.startsWith('HyperMD-table_'));
        if (!cls) return;
        const sl = row.scrollLeft;
        cm_code.querySelectorAll('.' + cls).forEach((peer) => {

          if (peer !== row && peer.scrollLeft !== sl) peer.scrollLeft = sl;
        });
      };
      cm_code.addEventListener('scroll', this.handleTableScroll, { capture: true, passive: true });
    };

    this.updateMessageWidgets = (active_line = null) => {
      if (!this.editor) return;

      this.clearMessageWidgets();
      this.messageRanges = [];
      let is_block = false;
      let block_lines = [];
      let start_line = 0;
      let block_type = null;

      const last_line = this.editor.lastLine();

      for (let line = this.editor.firstLine(); line <= last_line; line++) {

        const text = this.editor.getLine(line);

        if (!is_block) {

          const matched = text.trim().match(/^```([a-zA-Z0-9_-]+)\b/);
          if (matched) {
            block_type = matched[1];

            if (!this.widgetFactories[block_type]) {
              continue;
            }

            is_block = true;
            block_lines = [];
            start_line = line;
          }

          continue;
        }

        if (text.trim() === '```') {
          this.messageRanges.push({ start: start_line, end: line });

          const mark_from = { line: start_line, ch: 0 };

          const end_ch = this.editor.getLine(line).length;

          const mark_to = { line: line, ch: end_ch };

          const is_active = active_line !== null && active_line >= start_line && active_line <= line;

          if (!is_active) {

            const content = block_lines.join('\n').trim();

            const widget = this.widgetFactories[block_type](content, start_line);

            this.messageMarks.push(this.editor.markText(mark_from, mark_to, {

              replacedWith: widget,

              collapsed: true,

              inclusiveLeft: false,
              inclusiveRight: false,

              handleMouseEvents: true,

              clearOnEnter: false,
            }));

            for (let i = start_line; i <= line; i++) {
              const handle = this.editor.getLineHandle(i);
              this.messageLineHandles.push(handle);
              this.editor.addLineClass(handle, 'background', 'editor-message-codeblock');
              if (i > start_line) {
                this.editor.addLineClass(handle, 'wrap', 'editor-message-hidden');
              }
            }
          }
          is_block = false;
          block_type = null;
          continue;
        }
        block_lines.push(text);
      }
    };

    this.scheduleWidgetUpdate = () => {
      if (!this.editor) return;
      if (this._widgetUpdateRaf) return;
      this._widgetUpdateRaf = requestAnimationFrame(() => {
        this._widgetUpdateRaf = null;
        if (!this.editor) return;
        const cursor_line = this.editor.getCursor().line;
        this.updateMessageWidgets(cursor_line);
        this.updateFrontmatterWidget(cursor_line);
      });
    };

    this.on('mount', () => {
      if (spat.isBrowser) {
        const HyperMD = global.HyperMD;

        const extraKeys = {};

        if (!this.opts.isPlaceholder) {
          for (let key in app.shortcut.views.editor.commands) {

            const shortcutKey = key.split('+').map(k => k[0].toUpperCase() + k.substr(1)).join('-');
            const actionName = app.shortcut.views.editor.commands[key];
            extraKeys[shortcutKey] = () => {
              app.shortcut.run(actionName, this);
            };
          }
        }

        this.editor = HyperMD.fromTextArea(this.refs.editor, {
          mode: {
            name: 'hypermd',
            hashtag: true,
          },
          lineNumbers: false,
          highlightFormatting: true,
          selectionsMayTouch: true,
          tabSize: 2,
          readOnly: !!this.opts.isPlaceholder,

          extraKeys,
        });
        this.editor.setSize(null, '100%');

        requestAnimationFrame(() => {
          this.editor.display.sizer.style.marginLeft = this.editor.display.gutters.offsetWidth + "px";
        });

        this.util = new app.EditorUtil(this.editor);

        if (this.opts.isPlaceholder) return;

        if (app.useragent?.isMobile) this.editor.on('beforeChange', (cm, change) => {
          if (change.origin !== '+input') return;
          const removed = cm.getRange(change.from, change.to);
          const inserted = change.text.join('\n');
          if (inserted.length >= removed.length || !/!\[/.test(removed)) return;

          change.update(change.to, change.to, change.text);
        });

        Promise.resolve().then(() => {
          if (!this.editor) return;
          this.updateMessageWidgets();
          this.updateFrontmatterWidget();
          this.setupTableScrollSync();
        });
        this.editor.on('keydown', (cm, e) => {
          if (e.code === 'Escape') {
            if (this._prevKeyIsEscape) {

              this.blur();
            }
            this._prevKeyIsEscape = true;
          }
          else {
            this._prevKeyIsEscape = false;
          }
        });

        this.editor.on("inputRead", this.onInputRead);

        this._editorWrapper = this.editor.getWrapperElement();
        this._onComposingPlaceholderStart = () => {
          this._editorWrapper.classList.add('composing-placeholder');
        };

        this._onComposingPlaceholderEnd = () => {
          this._editorWrapper.classList.remove('composing-placeholder');
          setTimeout(() => { this.showHint(); }, ONE_FRAME_MS);
        };
        this._editorWrapper.addEventListener('compositionstart', this._onComposingPlaceholderStart);
        this._editorWrapper.addEventListener('compositionend', this._onComposingPlaceholderEnd);

        this.editor.on('cursorActivity', (cm) => {

          this.scheduleWidgetUpdate();
          const selected_text = cm.getSelection();
          if (this.overlay) {
            this.overlay.close();
            this.overlay = null;
          }

          if (selected_text) {
            this.showPopupMenu(selected_text);
          }
        });

        this.editor.setOption('hmdInsertFile', (files, action) => {
          const file = files[0];
          if (!file) {

            return true;
          }

          const $placeholder = document.createElement('span');
          $placeholder.className = 'alog-insert-file-placeholder';
          action.setPlaceholder($placeholder);

          const isImage = /image\//.test(file.type);
          const fileName = file.name;
          let blobURL;
          if (isImage) {
            const $image = document.createElement('img');
            blobURL = URL.createObjectURL(file);
            $image.title = fileName;
            $image.onload = () => { action.resize(); };
            $image.src = blobURL;
            $placeholder.appendChild($image);
          }
          else {
            $placeholder.textContent = `[Uploading...](${file.name})`;
          }
          this.isUploading = true;
          app.utils.debouncedUpdate();

          app.utils.uploadFile(file, this.opts.project.data.is_sensitive).then((url) => {

            if (blobURL) {
              URL.revokeObjectURL(blobURL);
            }
            let text = `[${file.name}](${url})\n`;
            if (isImage) {
              text = '!' + text;
            }

            action.finish(text);
          }).catch((err) => {
            console.error(err);
            action.finish('エラーが発生しました。');
          }).finally(() => {
            this.isUploading = false;
            app.utils.debouncedUpdate();
          });
          return true;
        });

        this.editor.setOption('hmdClick', {
          enabled: true,
          handler: (e) => {
            const open_link = () => {
              if (!capacitor.isAvailable && (this.mousedownMetaKey || e.ctrlKey || e.shiftKey)) {
                const url = new URL(e.url, location.origin);
                let is_note_url = app.utils.isNoteUrl(url);

                if (is_note_url) {
                  url.searchParams.set('view', 'list');
                }
                open(url.href);
              }
              else {
                app.utils.openMarkdownLink(new URL(e.url, location.origin));
              }
            };

            if (e.type === 'url') {

              if (e.text[0] === '(') {

                const urlToken = this.editor.getTokenAt({line: e.pos.line, ch: e.pos.ch - 1});

                const markdownToken = this.editor.getTokenAt({line: e.pos.line, ch: urlToken.start - 1});

                if (this.isClickedImageDeleteButton) {
                  const line = this.editor.getLine(e.pos.line);
                  const image_token_matched_list = [...line.matchAll(/!\[/g)];

                  let start_token_index = image_token_matched_list.reduce((index, matched) => {
                    const diff = e.pos.ch - matched.index;
                    if (diff > 0) {
                      if (e.pos.ch - index > diff) {
                        return matched.index;
                      }
                    }
                    return index;
                  }, -Infinity);

                  if (line[start_token_index - 1] === '[') {
                    start_token_index--;
                  }
                  const from = { ch: start_token_index, line: e.pos.line };
                  const to = { ch: e.pos.ch, line: e.pos.line };
                  this.editor.replaceRange('', from, to);
                  this.isClickedImageDeleteButton = false;
                  setTimeout(()=>{
                    this.focus();
                    this.editor.setCursor(e.pos);
                  }, 16)
                  return
                }

                if ((markdownToken.type || '').split(' ').includes('image')) {

                  spat.modal.open('modal-imageviewer', {image: e.url});
                }

                else {
                  open_link();
                }
                setTimeout(() => {

                  this.editor.setCursor({ line: e.pos.line - 1, ch: 0 });

                  this.editor.setCursor(e.pos);
                }, 16);
              }

              else {
                open_link();
              }
              setTimeout(() => {
                this.blur();
              }, 16);
            }
            else if (e.type === 'hashtag') {
              if (e.text === '#today') {
                let cursor = this.editor.getCursor({line: 0, ch: 0});
                let value = this.editor.getValue();

                value = value.replace(e.text, dayjs().format('YYYY/MM/DD(ddd)'));

                this.editor.setValue(value);
                this.editor.setCursor(cursor);

              }
            }
          },
        });

        this.editor.on('click', (e) => {
          this.trigger('click');
        });
        this.editor.on('focus', (e) => {
          if (!this._notClosePopupOnFocus) {
            spat.popup.closeAll();
          }
          this.trigger('focus');
          app.utils.debouncedUpdate();
          this.updateFrontmatterWidget(this.editor.getCursor().line);
        });
        this.editor.on('blur', (e) => {
          this.trigger('blur');
          app.utils.debouncedUpdate();
          this.updateFrontmatterWidget(this.editor.getCursor().line);
        });
        this.editor.on('change', (e) => {

          this.scheduleWidgetUpdate();
          this.trigger('change');
        });
        this.editor.on('paste', (cm, e) => {
          this.insertUrlSelectedRange(e);
        });

        this.scroller = this.editor.getScrollerElement();
        this.scroller.addEventListener('scroll', this.throttleUpdateToc);

        this.setupImageObserver();
      }
    });

    this.on('unmount', () => {
      if (this._widgetUpdateRaf) {
        cancelAnimationFrame(this._widgetUpdateRaf);
        this._widgetUpdateRaf = null;
      }
      this.clearMessageWidgets();
      this.clearFrontmatterWidget();
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.throttleUpdateToc);
      }
      if (this._editorWrapper) {
        this._editorWrapper.removeEventListener('compositionstart', this._onComposingPlaceholderStart);
        this._editorWrapper.removeEventListener('compositionend', this._onComposingPlaceholderEnd);
        this._editorWrapper = null;
      }
      if (this.imageObserver) {
        this.imageObserver.disconnect();
        this.imageObserver = null;
      }
      if (this.tableScrollTarget) {
        this.tableScrollTarget.removeEventListener('scroll', this.handleTableScroll, { capture: true });
        this.tableScrollTarget = null;
      }
    });

    this.setupImageObserver = () => {
      const append_button = (imgElement, index) => {

        if (imgElement.parentElement.querySelector('.delete-text')) {
          return;
        }

        const icon = document.createElement('i');
        icon.className = 'icon-stash_box text-label_dark_medium fs20';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'delete-text';

        button.appendChild(icon);

        imgElement.parentElement.appendChild(button);

        button.addEventListener('mouseup', (e) => {
          this.isClickedImageDeleteButton = true;
        });
      };

      const observer = new MutationObserver((mutationList, observer) => {
        const img_elements = this.root.querySelectorAll('img.hmd-image');
        img_elements.forEach(append_button);
      });

      this.imageObserver = observer;

      observer.observe(this.root, { subtree: true, childList: true });
    };

    this.onMousedown = (e) => {
      this.mousedownMetaKey = e.metaKey;
    };

    this.updateToc = () => {
      if (!this.popupToc) return ;
      const sections = Array.from(this.editor.display.wrapper.querySelectorAll('.HyperMD-header-2'));
      this.popupToc.setSections(sections);

      let scroll_top = this.editor.getScrollInfo().top;
      let index = sections.findIndex(section => app.utils.cumulativeOffset(section, this.scroller) > scroll_top);

      if (index !== 0) {
        index -= 1;
      }

      if (index < 0) {
        index = sections.length - 1;
      }
      this.popupToc.setCurrentIndex(index);
    };

    this.throttleUpdateToc = _.throttle(this.updateToc, 64);

    this.openPopupToc = (e) => {
      this.popupToc = spat.popup.open('popup-toc', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 4,
        align: { x: 'right'},
        position: 'bottom',
        opts: {
          body: this.scroller,
        },
      }).on('close', () => {
        this.popupToc = null;
        this.update();
      });
      this.updateToc();
    };

    this.onEditorMouseEnter = () => {
      this.isHoveringEditor = true;
    };

    this.onEditorMouseLeave = () => {
      this.isHoveringEditor = false;
    };

    this.on('pick', ({ completion }) => {

      this._notClosePopupOnFocus = true;
      setTimeout(() => {
        this._notClosePopupOnFocus = false;
      }, 16);
      if (!completion.hint) {

        this.focus();
      }
    });

    this.focus = () => {
      if (this.opts.isPlaceholder) return ;
      this.editor.focus();

    };

    this.blur = () => {
      if (this.opts.isPlaceholder) return ;
      this.editor.display.input.blur();
    };

    this.setValue = (v) => {
      this.editor.clearHistory();
      this.editor.clearGutter();
      try {
        this.editor.setValue(v);
      } catch(e){

      }
      if (!this.opts.isPlaceholder) {
        this.blur();
      }
    };

    this.getValue = () => {
      return this.editor.getValue();
    };

    this.syncValue = (v) => {

      if (this.editor.getValue() === v) return;

      let cursor = this.editor.getCursor();
      let scroll_info = this.editor.getScrollInfo();

      this.editor.setValue(v);

      let last_line = this.editor.lastLine();
      let line = Math.min(cursor.line, last_line);
      let ch = Math.min(cursor.ch, this.editor.getLine(line).length);
      this.editor.setCursor({line, ch});

      this.editor.scrollTo(scroll_info.left, scroll_info.top);
    };

    this.hasFocus = () => {

      return document.hasFocus() && this.editor.hasFocus();
    };

    this.onInputRead = (cm, change) => {
      this.showHint();
    };

    this.showHint = () => {
      const cm = this.editor;

      if (cm.state.completionActive) return ;

      const mentions = this.opts.mentions || [];

      const MAX_MENTION_LENGTH = Math.max(...mentions.map(m => m.item.data.screen_name.length));
      let cursor = cm.getCursor(), line = cm.getLine(cursor.line);
      let start = cursor.ch;
      let checkCount = 0;
      while (start !== 0) {
        const s = line[start - 1];

        if (/\s/.test(s)) break;

        if (['@', '＠'].includes(s)) {
          cm.showHint({

            completeSingle: false,

            hint: this.createHintFunc(start, mentions.map(mention => {
              return {

                value: `@${mention.item.data.screen_name} `,

                text: `@${mention.item.data.screen_name} ${mention.item.data.display_name}`,

                render: (hintElement) => {
                  const $elm = document.createElement('div');
                  const riotTag = riot.mount($elm, 'atom-editor-mention_', { mention })[0];
                  hintElement.innerHTML = $elm.innerHTML;
                  riotTag.unmount();
                },
              };
            })),
          });
          return ;
        }
        else if (s === '/') {
          cm.showHint({

            completeSingle: false,

            hint: this.createHintFunc(start, [
              { text: '/today', value: dayjs().format("YYYY/M/D(ddd)") },
              { text: '/tomorrow', value: dayjs().add(1, 'day').format("YYYY/M/D(ddd)") },
              { text: '/yesterday', value: dayjs().add(-1, 'day').format("YYYY/M/D(ddd)") },
              {
                text: '/assign',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.trigger('editorCommand', {
                    command: 'assign',
                    editor,
                    data,
                    completion,
                    tag: this
                  });
                }
              },
              {
                text: '/link',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.onOpenLinkPopup();
                }
              },
              {
                text: '/note',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.trigger('editorCommand', {
                    command: 'note',
                    editor,
                    data,
                    completion,
                    tag: this
                  });
                }
              },
              {
                text: '/table',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.trigger('editorCommand', {
                    command: 'table',
                    editor,
                    data,
                    completion,
                    tag: this
                  });
                }
              },
              {
                text: '/templates',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.trigger('editorCommand', {
                    command: 'templates',
                    editor,
                    data,
                    completion,
                    tag: this
                  });
                }
              },
              {
                text: '/calendar',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.onOpenPopupCalendar();
                }
              },
              {
                text: '/image',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.onInsertFile();
                }
              },
              {
                text: '/frontmatter',
                hint: (editor, data, completion) => {

                  editor.replaceRange('', data.from, data.to, "complete");
                  this.insertFrontmatterTemplate();
                }
              },
            ]),
          });
          return ;
        }
        --start;
        ++checkCount;

        if (checkCount > MAX_MENTION_LENGTH) break;
      }
    };

    this.createHintFunc = (start, items) => {

      return (cm, hints) => {
        let cursor = cm.getCursor(), line = cm.getLine(cursor.line);
        let end = cursor.ch;

        const inputWord = line.slice(start, end);

        const searchedItems = app.utils.fuzzySearchItems({
          items: items,
          value: inputWord,
          key_or_callback: item => item.text,
        });
        const list = searchedItems.map(item => {
          const DEFAULT_RENDER = (element) => {
            element.classList.add('px6', 'py4', 'CodeMirror-hint', 'hover-trigger', 'hover-bg-pale', 'font-lato');
            element.innerHTML = `<span>${item.text}</span>`;
          };
          return {
            text: item.value,
            render: item.render || DEFAULT_RENDER,

            hint: item.hint,
          }
        });

        let data = {
          list,
          from: CodeMirror.Pos(cursor.line, start - 1),
          to: CodeMirror.Pos(cursor.line, end),
          _handlers: {

            pick: [ (completion) => { this.trigger('pick', { data, completion }); } ],
          }
        };
        return data;
      };
    };

    this.insertFile = (target) => {

      this.editor.hmd.InsertFile.doInsert(target);
    };

    this.setCursorToLast = () => {
      this.util.setCursorToLast();
    };

    this.insertTextAtCursor = (text) => {
      this.util.insertTextAtCursor(text);
    };

    this.insertFrontmatterTemplate = () => {
      const content = this.editor.getValue();

      if (/^---\s*\r?\n/.test(content)) {
        spat.toast.message('既に frontmatter があります');
        this.editor.focus();
        return;
      }

      const template = '---\nkey: value\n---\n';
      this.editor.replaceRange(template, { line: 0, ch: 0 });

      this.editor.setSelection(
        { line: 1, ch: 0 },
        { line: 1, ch: 3 }
      );
      this.editor.focus();
    };

    this.insertLink = ({url, title, bold = false}) => {
      let insert_text = app.utils.getInsertLinkToTitle({url, title, bold});
      this.insertTextAtCursor(insert_text);
    };

    this.getCursor = () => {
      return this.root.querySelector('.CodeMirror-cursor') || this.root.querySelector('.CodeMirror-line:not(.hmd-inactive-line)') || document.activeElement;
    };

    this.on('mount', () => {
      this.fileInput = app.utils.createImageFileInput('image/*');
      this.fileInput.onchange = (e) => {
        this.insertFile(e.target);
        this.focus();
      };
    });

    this.onInsertFile = () => {

      this.fileInput.value = '';
      this.fileInput.click();
    };

    this.onOpenPopupCalendar = async (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const $cursor = this.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      const POPUP_HEIGHT = 327;

      let difference_height = cursorPosition.top > POPUP_HEIGHT ? POPUP_HEIGHT : -16;
      const popup = spat.popup.open('popup-calendar', {
        offsetTop: cursorPosition.bottom - difference_height,
        offsetLeft: cursorPosition.left - 40,
        closeTarget: e ? e.currentTarget : '',
      });
      await popup.waitClose();
      if (popup.value) {
        this.insertTextAtCursor(popup.value);
        this.focus();
      }
    };

    this.onOpenLinkPopup = async () => {
      const $cursor = this.getCursor();
      const cursorPosition = $cursor.getBoundingClientRect();
      const popup = spat.popup.open('popup-link', {
        offsetTop: cursorPosition.bottom - 80,
        offsetLeft: cursorPosition.left,
      }).on('submit', (e) => {
        popup.close();
      });
      popup.focusInput();
      await popup.waitClose();
      if (popup.value) {
        this.insertTextAtCursor(popup.value.text);
        this.focus();
      }
    };

});
riot.tag2('atom-editor-mention_', '<div class="f fm py6 px12 hover-trigger hover-bg-pale"><img class="circle object-fit-cover s16 flex-fixed mr4" if="{isUser()}" riot-src="{app.utils.getImageUrl(opts.mention.item.data.icon_image)}"> <div class="fs12 lh13 font-lato bold flex-fixed mr4">{getScreenName()}</div> <div class="f fm fbw w-full" if="{isUser()}"> <div>{opts.mention.item.data.display_name}</div> <div class="f fh bg-label_dark_disabled rounded-4 px4 py3 ml6" if="{opts.mention.label}"> <div class="fs10 text-label_dark_primary">{opts.mention.label}</div> </div> </div> <div class="fs10 lh13" if="{isGroup()}">{getTargetText()}</div> </div>', '', '', function(opts) {
    this.isUser = () => {
      return this.opts.mention.type === 'user';
    };

    this.isGroup = () => {
      return this.opts.mention.type === 'group';
    };

    this.getScreenName = () => {
      const {screen_name} = this.opts.mention.item.data;
      if (this.isUser()) {
        return screen_name;
      }

      else if (this.isGroup()) {
        return `@${screen_name}`;
      }
    };

    this.getTargetText = () => {
      const group = this.opts.mention.item;

      if (group.data.is_everyone) {
        return 'このプロジェクト内の全員に通知';
      }
      return `${group.data.screen_name}グループにアサインされているメンバーに通知`;
    };
});